<template>
  <div></div>
</template>

<script>
export default {
  name: 'ImagePreloader',
  props: {
    images: {
      type: Array,
      required: true
    },
    showProgress: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadedImages: 0,
      totalImages: 0,
      loadingProgress: 0
    }
  },
  computed: {
    isComplete() {
      return this.loadedImages >= this.totalImages;
    }
  },
  watch: {
    images: {
      immediate: true,
      handler(newImages) {
        if (newImages && newImages.length > 0) {
          this.preloadImages();
        }
      }
    },
    isComplete(newVal) {
      if (newVal) {
        this.$emit('preload-complete', {
          totalImages: this.totalImages,
          loadedImages: this.loadedImages
        });
      }
    },
    loadingProgress(newVal) {
      this.$emit('progress-update', newVal);
    }
  },
  methods: {
    preloadImages() {
      this.loadedImages = 0;
      this.totalImages = this.images.length;
      this.loadingProgress = 0;
      
      if (this.totalImages === 0) {
        this.$emit('preload-complete', { totalImages: 0, loadedImages: 0 });
        return;
      }
      
      this.images.forEach((imageSrc, index) => {
        this.preloadSingleImage(imageSrc, index);
      });
    },
    
    preloadSingleImage(src, index) {
      const img = new Image();
      
      img.onload = () => {
        this.loadedImages++;
        this.updateProgress();
        console.log(`✓ Image ${index + 1}/${this.totalImages} loaded: ${src}`);
      };
      
      img.onerror = () => {
        this.loadedImages++;
        this.updateProgress();
        console.warn(`✗ Failed to load image ${index + 1}/${this.totalImages}: ${src}`);
      };
      
      // 添加隨機延遲以模擬真實網路環境
      const delay = Math.random() * 100;
      setTimeout(() => {
        img.src = src;
      }, delay);
    },
    
    updateProgress() {
      this.loadingProgress = (this.loadedImages / this.totalImages) * 100;
    }
  }
}
</script> 